import { useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { unwrapResult } from "@reduxjs/toolkit";

import LoginComponent from "./loginComponent";

import { completeChangeEmail, login } from "../../redux/state/accountSlice";

const Login = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const { search } = useLocation();
  const query = new URLSearchParams(search);

  const changeEmailToken = encodeURIComponent(query.get("token"));
  const userId = query.get("userId");
  const id = query.get("communityId");
  const campaignId = query.get("campaignId");
  const type = query.get("type") ?? query.get("pageType");

  const communityId = useSelector(
    (state) => state.account.userByParseToken.communityId,
    shallowEqual
  );

  const loginHandler = ({ email, password }) => {
    dispatch(login({ email, password }))
      .then(unwrapResult)
      .then(() => {
        if (!!communityId) {
          history.push(`/communities/community/${communityId}`);
          return;
        }
        if (!!id && !type) {
          history.push(`/communities/community/${id}/add-members`);
          return;
        }
        switch (type) {
          case "search":
            history.push("/my-com/search-community");
            break;
          case "create":
            history.push("/new-community");
            break;
          case "campaign":
            history.push(`/campaigns/campaign/active/${id}/${campaignId}`);
            return;
          default:
            history.push("/campaigns");
        }
      })
      .catch(({ title }) => console.error(title));
  };

  useEffect(() => {
    if (!!changeEmailToken && !!userId) {
      dispatch(completeChangeEmail({ userId, token: changeEmailToken }));
    }
  }, [userId, changeEmailToken, dispatch]);

  return <LoginComponent onLogin={loginHandler} />;
};

export default Login;
